/* eslint-disable no-undef */
import React, { useEffect, useState, Fragment } from 'react';
import { useSelector } from 'react-redux';
import BooleanEdit from './BooleanEdit';
import { SPECTRUM } from 'constants/predicates';

import { useDispatch } from 'react-redux';

const IsParentCollectionEdit = ({ field }) => {
  const dispatch = useDispatch();
  const specialCollectionChecked = useSelector(state => 
    state.field.fields[SPECTRUM.IS_SPECIAL_COLLECTION]?.values[0] === true
  )
  
  useEffect(() => {
    field.setDisabled(specialCollectionChecked);
    if(specialCollectionChecked){
    	field.setValue(0, false);
    }
  }, [specialCollectionChecked]);

  return (
      <BooleanEdit
        field={field} />
  );
};

export default IsParentCollectionEdit;